export default "__VITE_ASSET__C18Q5kXA__"